import { getFooterPortalReducer } from './footer';
import { getHomeInfoReducer } from './homeInfo';
import { portalNoticeReducer } from './portalNotice';
import { analyticsReducer } from './analytics';
import { listNewsPortalReducer } from './news';
import { getUnidadeDadosReducer } from './unidade';
import { servicosReducer } from './servicos';
import { mpfPermissoesReducer } from './permissoes';
import { mpfPerfisReducer } from './perfis';
import { mpfNotificacoesReducer } from './notificacoes';
import { intlCorrigidoReducer } from './intl';

export const customReducers = {
  footerPortal: getFooterPortalReducer,
  homeInfo: getHomeInfoReducer,
  portalNotice: portalNoticeReducer,
  analytics: analyticsReducer,
  listNewsPortal: listNewsPortalReducer,
  unidadeDados: getUnidadeDadosReducer,
  servicos: servicosReducer,
  mpfPermissoes: mpfPermissoesReducer,
  mpfPerfis: mpfPerfisReducer,
  mpfNotificacoes: mpfNotificacoesReducer,
  intl: intlCorrigidoReducer,
};

const reducers = {
  ...customReducers,
};

export default reducers;
